import { getPageAllowedRoles } from "../config/roles";
import { ListDefinition } from "./listDefinition.types";

const recordRoute = "/data-import";
const roles = getPageAllowedRoles("data-import");

/**
 * The data imports list. Every import comes back in one request, through the warehouse's
 * data import route, so its filters narrow what is already loaded. Imports can't be
 * edited, deactivated or deleted - a row opens the import's status.
 */
export const dataImportsListDefinition: ListDefinition = {
  path: "/data-imports",
  entityName: "dataimport",
  recordRoute,
  title: "Data Imports",
  allowedRoles: roles,
  data: "all-at-once",
  filters: [
    // Sources are each client's own, so the choices are the ones the imports name.
    {
      name: "source",
      label: "Source",
      kind: "picklist",
      optionsFromRows: true,
      width: "wide",
    },
    { name: "createdon", label: "Created", kind: "date-range" },
  ],
  filterByStatus: false,
  allowAdd: true,
  addRoles: roles,
  allowStatusEdit: false,
  defaultSortKey: "createdon",
  defaultSortDir: "desc",
  columns: [
    {
      key: "source",
      label: "Source",
      width: 300,
      sortable: true,
      link: { to: recordRoute, idKey: "Id", newTab: "button" },
    },
    {
      key: "existingcontactcount",
      label: "Existing Contact Count",
      width: 200,
      sortable: true,
    },
    {
      key: "newcontactcount",
      label: "New Contact Count",
      width: 200,
      sortable: true,
    },
    {
      key: "createdon",
      label: "Created On",
      width: 200,
      display: "datetime",
      sortable: true,
    },
  ],
};
